import React, { useEffect, useState } from 'react';
import './ReviewBadge.css';

const REVIEW_URL = 'https://share.google/3hfMUHz5ygAdwByuR';
const DISMISS_KEY = 'review_badge_closed';
const SHOW_DELAY_MS = 1000;

// Small floating Google-rating badge, window bottom-left, homepage only
// (mounted in App.js). Appears 1s after load with a fade-in; clicking it
// opens our Google reviews in a new tab; the × hides it for the rest of
// the session (sessionStorage).
function ReviewBadge() {
  const [closed, setClosed] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  if (closed || !visible) return null;

  const close = () => {
    setClosed(true);
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* private mode */ }
  };

  return (
    <div className="review-badge">
      <button
        type="button"
        className="review-badge__close"
        aria-label="Hide reviews badge"
        onClick={close}
      >
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </svg>
      </button>
      <a
        href={REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Read our Google reviews (opens in a new tab)"
      >
        <img src="/review.jpg" alt="Google rating: 5.0 stars" width="300" height="100" loading="lazy" decoding="async" />
      </a>
    </div>
  );
}

export default ReviewBadge;
